export enum GenderType {
  Male = "Male",
  Female = "Female"
}
